import Head from 'next/head';
import {useRouter} from 'next/router';

import {HeadSEO, useCanonicalUrl} from '@udemy/head-seo';
import {useI18n} from '@udemy/i18n';
import {ExperimentationProvider} from '@udemy/react-experimentation-provider';

import {getLayout} from 'src/components/layout';

import {
    AUTH_FULL_PAGE_REDIRECT,
    DELAYED_ACCOUNT_CREATION_ON_CHECKOUT_PAGE,
    EMPTY_CART_FEATURE_VARIANT,
    CART_UPSELL_FEATURE,
    SHOPPING_CART_VARIANT_MOBILE,
    CART_RECOMMENDATION_FEATURES,
} from '../../lib/experimentation-helper';
import {Cart} from './cart.react-component';

export const cartPageExperimentationFeatures = [
    AUTH_FULL_PAGE_REDIRECT,
    DELAYED_ACCOUNT_CREATION_ON_CHECKOUT_PAGE,
    EMPTY_CART_FEATURE_VARIANT,
    CART_UPSELL_FEATURE,
    SHOPPING_CART_VARIANT_MOBILE,
    CART_RECOMMENDATION_FEATURES,
];

export const CartPage: React.FC = () => {
    const router = useRouter();
    const {gettext} = useI18n();
    const {url: canonicalUrl} = useCanonicalUrl(router as Required<typeof router>);
    return (
        <>
            <HeadSEO
                title={gettext('Cart') + ' | Udemy'}
                assetPath={process.env.ASSET_PREFIX}
                canonicalUrl={canonicalUrl}
                headWrapper={({children}) => (
                    <Head>
                        <meta httpEquiv="Cache-Control" content="no-store" />
                        {children}
                    </Head>
                )}
            />
            <ExperimentationProvider features={cartPageExperimentationFeatures}>
                <Cart />
            </ExperimentationProvider>
        </>
    );
};

// eslint-disable-next-line
(CartPage as any).getLayout = getLayout;
